import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // For navigation on button click
import { toast, ToastContainer } from "react-toastify"; // Import react-toastify
import "react-toastify/dist/ReactToastify.css"; // Import the styles for react-toastify

const BusinessName = () => {
  const [businessName, setBusinessName] = useState("");
  const navigate = useNavigate(); // Initialize the navigate function
  
  const handleSubmit = async (e) => {
    e.preventDefault();

    

    const user = JSON.parse(localStorage.getItem("user"));
    if (!user || !user.id) {
      toast.error("User not found. Please log in again.");
      navigate("/");
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_API}/api/intro-data`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userId: user.id,
          page: 2,
          data: { businessName },
        }),
      });

      const data = await response.json();
      if (response.ok) {
        toast.success("Excellent!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        console.log("Business Name saved:", data.introData);
        setTimeout(() => navigate("/url-page"), 1000);
      } else {
        toast.error(data.error || "Failed to save business name.");
      }
    } catch (error) {
      console.error("Error saving business name:", error);
      toast.error("An error occurred. Please try again.");
    }
  };



  const handleSkip = () => {
    navigate("/url-page");
  };




  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-4 sm:p-6 md:p-8">
  {/* Main Content */}
  <div className="flex flex-col items-center text-center w-full max-w-2xl mx-auto">
    {/* Full-Width Heading */}
    <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4 px-4 w-screen">
      First, What is the name of your business?
    </h1>

    {/* Subheading */}
    <p className="text-gray-600 text-sm sm:text-base md:text-xl lg:text-2xl mb-6 md:mb-8 px-4">
      We will use this to set up your agent
    </p>

    {/* Input Field */}
    <form onSubmit={handleSubmit} className="w-full px-4">
      <label htmlFor="businessName" className="text-base sm:text-lg font-medium mb-2 block">
        Business Name
      </label>
      <input
        type="text"
        id="businessName"
        value={businessName}
        onChange={(e) => setBusinessName(e.target.value)}
        placeholder="Enter your business name"
        className="border border-gray-300 rounded-lg px-3 py-2 sm:px-4 sm:py-2 w-full focus:outline-none focus:border-blue-500 mb-4 text-sm sm:text-base"
      />

      {/* Continue Button */}
      <button
        type="submit"
        className="bg-blue-600 text-white font-medium py-2 sm:py-3 px-4 sm:px-6 rounded-lg hover:bg-blue-700 transition-colors w-full text-sm sm:text-base"
      >
        Continue
      </button>

      <button
              type="button"
              onClick={handleSkip}
              className="bg-gray-200 text-gray-700 font-medium py-2 sm:py-3 px-4 sm:px-6 rounded-lg hover:bg-gray-300 transition-colors w-full text-sm sm:text-base"
            >
              Skip
            </button>
    </form>
  </div>

  {/* Pagination Dots */}
  <div className="mt-6 sm:mt-8 md:mt-10 flex space-x-2 justify-center">
    {/* Dot 1 */}
    <div className="w-2 h-2 sm:w-3 sm:h-3 bg-gray-300 rounded-full"></div>
    {/* Dot 2 (Highlighted) */}
    <div className="w-2 h-2 sm:w-3 sm:h-3 bg-gray-900 rounded-full"></div>
    {/* Dot 3 */}
    <div className="w-2 h-2 sm:w-3 sm:h-3 bg-gray-300 rounded-full"></div>
    {/* Dot 4 */}
    <div className="w-2 h-2 sm:w-3 sm:h-3 bg-gray-300 rounded-full"></div>
    {/* Dot 5 */}
    <div className="w-2 h-2 sm:w-3 sm:h-3 bg-gray-300 rounded-full"></div>
  </div>

  {/* Toast Container */}
  <ToastContainer />
</div>
  );
};

export default BusinessName;